import React from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap'
import CopyDocumentation from './copydocumentation'
import CopyGraphic from './copygraphic'
import CopyTemplate from './copytemplate'

function Copy() {

	return (
		<Container>
			<Tabs>
				<Tab eventKey="copytemplate" title="Kopiera mallar">
					<CopyTemplate/>
				</Tab>
				<Tab eventKey="copygraphic" title="Kopiera grafik">
					<CopyGraphic/>
				</Tab>
				<Tab eventKey="copydocumentation" title="Kopiera dokumentation">
					<CopyDocumentation/>
				</Tab>
			</Tabs>
		</Container>
	)
}

export default Copy